// Route::get('/ScriptGameRoomPage', \App\Api\ScriptGameRoom\ReadPage\ReadScriptGameRoomPageController::class);
// Route::post('/ScriptGameRoom', \App\Api\ScriptGameRoom\CreateOne\CreateOneScriptGameRoomController::class)->middleware(['auth']);
// Route::delete('/ScriptGameRoom/{id}', \App\Api\ScriptGameRoom\DeleteOne\DeleteOneScriptGameRoomController::class)->middleware(['auth']);
// Route::put('/ScriptGameRoom/{id}', \App\Api\ScriptGameRoom\UpdateOne\UpdateOneScriptGameRoomController::class)->middleware(['auth']);
// Route::post('/ScriptGameRoomStart/{id}', \App\Api\ScriptGameRoom\StartOne\StartOneScriptGameRoomController::class)->middleware(['auth']);
import { MateSpriteDirection, MateSpriteTaskMode } from "@/enums/game";
import { get, post, deleteOne, put } from "@/modules/request";
import { PageRequest, Response, WriteResponse } from "@/types/api-types";
import { Mate, Media } from "@/types/entity";
import {
  MateSprite,
  MateSpriteMode,
  N8nTaskStatus,
  ScriptGameRoom,
  ScriptGameRoomPlayer,
} from "@/types/game";

// Route::post('/ScriptGameRoomPlayer', \App\Api\ScriptGameRoomPlayer\CreateOne\CreateOneScriptGameRoomPlayerController::class)->middleware(['auth']);
// Route::put('/ScriptGameRoomPlayer/{id}', \App\Api\ScriptGameRoomPlayer\UpdateOne\UpdateOneScriptGameRoomPlayerController::class)->middleware(['auth']);
// Route::delete('/ScriptGameRoomPlayer/{id}', \App\Api\ScriptGameRoomPlayer\DeleteOne\DeleteOneScriptGameRoomPlayerController::class)->middleware(['auth']);

export const readScriptGameRoomPage = async (userId?: number) =>
  get("/ScriptGameRoomPage", {
    filter: {
      userId,
      // isPreset,
    },
    sort: { field: "dtUpdate", order: "desc" },
  });

export const readScriptGameRoom = async (uuid: string) =>
  get("/ScriptGameRoom/" + uuid);

export const createScriptGameRoom = async (data: ScriptGameRoom) =>
  post("/ScriptGameRoom", data);

export const deleteScriptGameRoom = async (id: number) =>
  deleteOne("/ScriptGameRoom/" + id);

export const updateScriptGameRoom = async (id: number, data: ScriptGameRoom) =>
  put("/ScriptGameRoom/" + id, data);

export const startScriptGameRoom = async (id: number) =>
  post("/ScriptGameRoomStart/" + id);

export const createScriptGameRoomPlayer = async (data: ScriptGameRoomPlayer) =>
  post("/ScriptGameRoomPlayer", data);

export const updateScriptGameRoomPlayer = async (
  playerId: number,
  data: ScriptGameRoomPlayer
) => put("/ScriptGameRoomPlayer/" + playerId, data);

export const deleteScriptGameRoomPlayer = async (playerId: number) =>
  deleteOne("/ScriptGameRoomPlayer/" + playerId);

export const readMateSpritePage = async (
  request: PageRequest<{
    mateId?: number;
    isOnScreen?: number;
  }>
) => get("/MateSpritePage", request);

export interface CreateMateSpriteParams {
  mateId: number;
  name?: string;
  prompt?: string | null;
  mode?: MateSpriteMode;

  referenceMediaId?: number | null;
  imageMediaId?: number;
  frameMediaId?: number | null;
  portraitMediaId?: number;
  avatarMediaId?: number;
  isDefault?: boolean;
  isOnScreen?: boolean;
  sourceSpriteId?: number;
}

export const createMateSprite = async (
  data: CreateMateSpriteParams
): Promise<WriteResponse<MateSprite>> => post("/MateSprite", data);

export interface UpdateMateSpriteParams {
  mateId?: number;
  name?: string;
  prompt?: string | null;
  mode?: MateSpriteMode;
  referenceMediaId?: number | null;
  imageMediaId?: number;
  frameMediaId?: number | null;
  portraitMediaId?: number | null;
  isDefault?: boolean;
  isOnScreen?: boolean;
  avatarMediaId?: number | null;

  animationzz?: {
    id: number;
    mediaId?: number;
  }[];
}

export const updateMateSprite = async (
  id: number,
  data: UpdateMateSpriteParams
): Promise<WriteResponse<MateSprite>> => {
  if (!id) throw new Error("id is required");
  return put("/MateSprite/" + id, data);
};

export const replaceMateSpriteFrame = async (data: {
  animationId: number;
  frameIndex?: number;
  mediaId: number;
}): Promise<Response<{ imageMedia: Media; animationMedia: Media }>> =>
  post("/MateSprite/ReplaceFrame", data);

export const deleteMateSprite = async (id: number) =>
  deleteOne("/MateSprite/" + id);

export const readMateSprite = async (
  uuid: string
): Promise<WriteResponse<MateSprite>> => get("/MateSprite/" + uuid);

export const cloneMateSprite = async (id: number) =>
  post("/MateSpriteClone/" + id);

export const readMateSpriteTask = async (taskId: string) =>
  get("/MateSpriteTask/" + taskId);

export const createMateSpriteTask = async (data: {
  spriteId: number;
  direction?: MateSpriteDirection;
  frameIndex?: number;
  referenceMediaId?: number;
  mode?: MateSpriteTaskMode;
  imageMediaId?: number;
  prompt?: string;
  method?: "reference" | "pixel" | "text";
}): Promise<Response<{ taskId: string }>> => post("/MateSpriteTask", data);

export const trialScriptGameRoom = async (
  id: number,
  data: { mateSpriteId: number; mateId: number }
) => post("/ScriptGameRoomTrial/" + id, data);

export const readMateSpritePresetPage = async (
  request: PageRequest<{
    isPreset?: number;
    isPartner?: number;
    gender?: number;
  }>
) => get("/MateSpritePage", request);

export const readMateSpritePreset = async (uuid: string) =>
  get("/MateSprite/" + uuid);

export const readMateGenerationTask = async (
  taskId: string
): Promise<
  Response<{
    status: N8nTaskStatus;
    result: {
      mate: Mate;
      sprite: MateSprite;
    };
  }>
> => get("/MateGenerationTask/" + taskId);

export const createMateGenerationTask = async (data: {
  referenceMediaId?: number;
  prompt?: string;
  gender?: number;
}): Promise<Response<{ taskId: string }>> => post("/MateGenerationTask", data);
